import { CombinedGraphQLErrors } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';

const errorLink = new ErrorLink(({ error, operation }) => {
  if (CombinedGraphQLErrors.is(error)) {
    error.errors.forEach(({ message }) => {
      // TODO: handle error
      // toast(message, {
      //   type: 'error',
      // });
    });
  }

  console.log({ error, operation });
  console.log(`[Network error]: ${error}`);
});

export default errorLink;
